<template>
  <div class="dialog-mask ordine-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div class="dialog-header">{{ 'OrderDetails' | lang }}</div>
      <div class="dialog-body">
        <div class="space-between"><span>{{ 'Price' | lang }}</span><span>{{ amount | currency }}</span></div>
        <div class="space-between"><span>{{ 'OrderId' | lang }}</span><span>{{ orderId }}</span></div>
        <div class="space-between"><span>{{ 'ProductsNumber' | lang }}</span><span>{{ order.OrderItemWebApi.length }}</span></div>
        <div class="space-between"><span>{{ 'OrderStatus' | lang }}</span><span>{{ order.OrderStatusLabel }}</span></div>
        <br />
        <div class="space-between"><span style="line-height: 50px;">{{ 'Receipt' | lang }}</span>  <button v-if="order.ReceiptAvailable==true"  @click="getReceipt(orderId)">{{ 'Download' | lang }}</button><span style="line-height: 50px;" v-else>{{ 'ReceiptNotAvailable' | lang }}</span></div>
        <br />
        <div class="multi-nav singlecol">
          <div v-for="(prod, i) in order.OrderItemWebApi" :key="i">
            <div v-content-attached-on-top class="nav-header hflex" :key="'h' + prod.Id">{{prod.Label || prod.ProductLabel}}<!--<div class="hspace"></div>{{prod.Amount / 100 | currency}}--></div>
            <!--<div class="sub">{{r.readAt}}</div>-->
            <ul class="nav" :key="prod.Id + 'nav'">
            <li class="space-between"><span>{{ 'Price' | lang }}</span><span>{{ prod.Amount / 100 | currency }}</span></li>
            <li class="space-between"><span>{{ 'Network' | lang }}</span><span>{{ prod.NetworkLabel }}</span></li>
            <li class="space-between"><span>{{ 'Status' | lang }}</span><span>{{ prod.OrderItemStatusLabel }}</span></li>
            <li v-if="!evidences" class="space-between"><span class="fa fa-fw fa-refresh fa-spin"></span></li>
         
            <li  v-if="evidences && evidences[prod.Id]  && evidences[prod.Id][0].Evidences && evidences[prod.Id][0].Evidences.length>0" class="space-between"><span>{{ 'Documents' | lang }}</span><button @click="openDettaglioDocumenti(prod)">{{ 'DocumentsDetail' | lang }}</button></li>

            <li v-if="prod.Description && prod.Description.length && !(prod.MediaType=='csc' && prod.ItemType=='cardOrdering')">{{ prod.Description[0] }}</li>  
            <li v-if="prod.MediaType=='csc' && prod.ItemType=='cardOrdering'">{{ 'CustomCscCardDescription' | lang  }}</li>   
          </ul>
          </div>
        </div>

        <!-- <div v-for="prod in order.OrderItemWebApi" :key="prod.Id">
          <div>
            <div v-content-attached-on-top class="nav-header hflex">{{prod.Label}}</div>
            <div class="space-between"><span>{{ 'Price' | lang }}</span><span>{{ prod.Amount / 100 | currency }}</span></div>
            <div class="space-between"><span>{{ 'Network' | lang }}</span><span>{{ prod.NetworkLabel }}</span></div>
            <div class="space-between"><span>{{ 'Status' | lang }}</span><span>{{ prod.OrderItemStatusLabel }}</span></div>
            <div v-if="prod.Description && prod.Description.length">{{ prod.Description[0] }}</div>
          </div>
        </div> -->
        <!-- <pre>{{order}}</pre> -->
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(true)">{{ 'Close' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>

import DettaglioDocumenti from '@/dialogs/DettaglioDocumenti'
import dialogMixin from '@/mixins/dialogMixin'
import saleableServices from '@/mixins/services/saleableServices'
import { create } from 'vue-modal-dialogs'

const DettaglioDocuementiDialogCreator = create(DettaglioDocumenti,'order','orderItem','evidences')

export default {
  name: 'DettaglioAcquisto',
  mixins: [ dialogMixin,saleableServices ],
  props: ['order'],
  computed: {
    amount () {
      return this.order.TotalCashAmount / 100
    },
    orderId () {
      return this.order.OrderId
    },
    items () {
      return this.order.OrderItemWebApi
    },
    itemGroupedByCsc () {
      let map = {}
      let k
      this.items.forEach(it => {
        k = `${it.MediaSerialNumber}_${it.MediaUnicity}`
        map[k] = map[k] || { MediaSerialNumber: it.MediaSerialNumber, MediaUnicity: it.MediaUnicity, lst: [] }
        map[k].lst.push(it)
      })
      return Object.values(map)
    }
  },
  data () {
    return {
      evidences:null
    }
  },
  methods: {
    getOrderData()
    { 
       return this.order.OrderCreationDate.substring(0, 10).replace(/-/g, '');
    },

    getEvidences()
    {
      var itemIds="";
      for(var i=0;i<this.order.OrderItemWebApi.length;i++)
      {
        itemIds=itemIds+this.order.OrderItemWebApi[i].Id;
        if(i<this.order.OrderItemWebApi.length-1)
          itemIds=itemIds+",";
      }
      this._getEvidences(this.order.OrderId,itemIds).then(evidences => {
      this.evidences=evidences;
            
    }).catch(e => {   
      evidences=[];
      this.internalBus.$emit('notify:error', {
        text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : '')
      })
    })
    },
    async openDettaglioDocumenti(prod)
    {
      var evidences=this.evidences[prod.Id]  
      if(evidences)
        {
      let changedDocuments = await DettaglioDocuementiDialogCreator(this.order,prod, evidences);
              if (changedDocuments) {
                this.evidences=null;
                this.getEvidences();
              }
          }
        else
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured')
        });
    },

    getReceipt(orderId)
    {
      this._getReceipt(orderId,this.getOrderData()).then(receipt => {
        this.download(receipt);
      }).catch(e => {
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : '')
        })
      })
    },
     download (response) {   
      let blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'reciept'+ this.orderId+'.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);        
     }

  },
  mounted() {
    this.getEvidences();
  }
 
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

$dett_sto_width: 25rem;
.ordine-dialog .dialog-content {
  min-width: $dett_sto_width;
      width: $dett_sto_width;
  max-width: $dett_sto_width;
}
#app.mobile .ordine-dialog .dialog-content {
  min-width: calc(100vw - 2rem);
      width: calc(100vw - 2rem);
  max-width: calc(100vw - 2rem);
}

#app.desktop .ordine-dialog .dialog-content .nav li
{
  cursor: default;
}

</style>
